import { buttonClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const AppliedFiltersContainer: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 20]),
    [theme.screen.tablet]: {
        padding: pxArrayToRem([0, 0, 25]),
    },
    [`& .${buttonClassName}`]: {
        paddingRight: pxToRem(40),
        margin: `${pxToRem(12)} 0`,
    },
    [`& .${svgIconClassName}`]: {
        height: pxToRem(20),
        width: pxToRem(20),
    },
});
